import Context from "./context";
import { config_get, config_set } from "../db/t_config";
import log from "../log";
import time from "../time";
import { friend_black_upsert, friend_black_del, FriendBlack, queryBlackLocal } from "../db/t_friend_black";
import { ExecuteResult } from "../db";

export class FriendBlackController {
  private static lastRefreshTime: number = 0;
  private static isRefreshing: boolean = false;

  public static async update_blacks(ctx: Context, uid: number, black: string): Promise<ExecuteResult> {
    if (black === "1") {
      const timeUNIX = time.toUnixMillSecond(time.now());
      return friend_black_upsert(ctx.db, { black: black, uid: uid, lutime: timeUNIX, lctime: timeUNIX });
    } else {
      return friend_black_del(ctx.db, uid);
    }
  }

  public static async query_blacks(ctx: Context): Promise<{ error: any; blacks?: FriendBlack[] }> {
    const r = await this.check_and_refresh_black(ctx);
    if (r.error === -1) {
      return queryBlackLocal(ctx.db);
    }
    return r;
  }

  private static async check_and_refresh_black(ctx: Context): Promise<{ error: any; blacks?: FriendBlack[] }> {
    if (FriendBlackController.isRefreshing) {
      return { error: -1 };
    }
    const db_key = "friend_black_fresh_time";
    if (FriendBlackController.lastRefreshTime === 0) {
      const rst = await config_get(ctx.db, db_key);
      if (rst.error) {
        log.error(
          `check_or_update获取${db_key}配置信息失败！`,
          rst.error
        );
        return { error: -1 };
      }
      if (rst.data && rst.data.val) {
        FriendBlackController.lastRefreshTime = parseInt(rst.data.val, 10); // 上一次成功刷新的时间
      }
    }
    // 检查两天内是否刷新过
    if (
      FriendBlackController.lastRefreshTime >
      time.toUnixMillSecond(time.add(time.now(), -2 * time.DAY))
    ) {
      return { error: -1 };
    }


    // 再次检查
    if (FriendBlackController.isRefreshing) {
      return { error: -1 };
    }
    FriendBlackController.isRefreshing = true;
    const res = await FriendBlackController.do_refresh_black(ctx);
    if (!res.error) {
      FriendBlackController.lastRefreshTime = time.toUnixMillSecond(
        time.now()
      );
      await config_set(
        ctx.db,
        db_key,
        FriendBlackController.lastRefreshTime.toString(10)
      );
    }
    FriendBlackController.isRefreshing = false;
    return res;
  }


  public static async do_refresh_black(
    ctx: Context
  ): Promise<{ error: any; blacks?: FriendBlack[] }> {
    const r = await ctx.conn.Call<BlackData>("/v1/sdk/user/black/list", {});
    if (!(r && r.code === 0)) {
      return { error: null };
    }
    const blacks: FriendBlack[] = [];
    if (r.data.blackRecords) {
      const records = r.data.blackRecords;
      const n = records.length;
      for (let i = 0; i < n; i++) {
        const record = records[i];
        blacks.push({ uid: record.blackUid, lutime: record.ctime, black: "1", lctime: record.ctime });
        await friend_black_upsert(ctx.db,
          {
            uid: record.blackUid,
            black: "1",
            lctime: record.ctime,
            lutime: record.ctime
          });
      }
    }
    return { error: null, blacks: blacks };
  }


}

export interface BlackData {
  blackRecords: { blackUid: number, ctime: number, }[];
  users: { uid: number, name: string, telno: string, email: string, avatar: string, }[];
}